// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + "component---src-pages-index-jsx" + "-" + "ce3672d909b1d5b595c2" + ".js";
};